import liveStatsPollActions from './live-stats.poll.actions'
import liveStatsScaleActions from './live-stats.scale.actions'
import liveStatsReactionActions from './live-stats.reaction.actions'
import liveStatsCountingActions from './live-stats.counting.actions'

const actions = {
  ...liveStatsPollActions,
  ...liveStatsScaleActions,
  ...liveStatsReactionActions,
  ...liveStatsCountingActions,
}

export default actions
